import { Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { ActivityService } from 'app/services/activity.service';
import { AttrIndexService } from 'app/services/attr-index.service';
import { DomainService, GivColumnDomain } from 'app/services/domain.service';
import { LayerCategoryStandardSchema } from 'app/services/field-mapping.service';
import { RCRecordItem, QaResolverFeed, ResoCenterCol, ResolutionCenterService, ResoCenterRule } from 'app/services/resolution-center.service';
import { ResolutionQcService } from 'app/services/resolution-qc.service';
import { RCCellChangeData } from '../rc-cell/rc-cell.component';

interface RCRecordItemExt extends RCRecordItem {
	domainsByColumn: {
		[prop: string]: GivColumnDomain;
	}
}

@Component({
  selector: 'app-resolution-dav',
  templateUrl: './resolution-dav.component.html',
  styleUrls: ['./resolution-dav.component.css', '../resolution-inspector/resolution-inspector.component.css']
})
export class ResolutionDAVComponent implements OnInit, OnChanges {

	@Input() resolverFeed: QaResolverFeed;

	@Output() edit: EventEmitter<any> = new EventEmitter();

	addrList: RCRecordItemExt[] = [];
	cols: ResoCenterCol[] = [];
	rules: ResoCenterRule[] = [];

	currentAddr: RCRecordItemExt;
	hoveredAddr: RCRecordItemExt;

	constructor(
		private elemRef: ElementRef,
		private activityService: ActivityService,
		private attrIndexService: AttrIndexService,
		private domainService: DomainService,
		private resoCenterService: ResolutionCenterService,
		private resoQcService: ResolutionQcService
	) { }

	clickAddr(addr: RCRecordItemExt) {
		this.addrList.forEach(a => {
			a.isCurrent = a === addr;
			if (a.isCurrent) {
				this.currentAddr = a;
			}
		});
	}
	onEditCell(idx, e: RCCellChangeData) {
		// this.addrList[idx].props[e.col.prop] = e.val;
		this.resoCenterService.onEditRecord(this.addrList[idx], e.col);

		this.edit.emit({
			changedCols: [e.col]
		});
		
		// const addressQcCodes = this.resoQcService.qcCheckAddress(this.addrList, [e.col.prop], this.cols.map(c => c.prop));
		// const generalQcCodes = this.resoQcService.qcCheckGeneral(this.addrList, this.cols, this.elemRef);
		// addressQcCodes.concat(generalQcCodes).forEach(i => {
		// 	const rule = this.rules.find(r => r.code === i.code);
		// 	if (rule) {
		// 		rule.isFixed = !i.isFailed;
		// 	} else {
		// 		this.rules.push({
		// 			code: i.code,
		// 			isFixed: !i.isFailed
		// 		})
		// 	}
		// });

	}

	private async onFeedChange() {
		if (!this.resolverFeed) {
			this.addrList = [];
			this.cols = [];
			this.rules = [];
			return;
		}
		const layerCateCode = Object.keys(this.resolverFeed.feed)[0];
		//
		this.cols = await this.resoCenterService.transformCols(this.resolverFeed.feed[layerCateCode].cols, layerCateCode);

		const addrList = await this.resoCenterService.transformItemList(this.resolverFeed, layerCateCode);
		// Add Domains
		const layerCate = this.activityService.selectedLayerBS.getValue().layer.category;
		const colsForDomain: {prop; standard: LayerCategoryStandardSchema}[] = this.cols.map(c => {
			return {
				prop: c.prop,
				standard: layerCate.standardCols.find(s => s.colName === c.standardName)
			}
		});
		this.addrList = addrList.map(i => {
			const domainsByColumn = this.domainService.getColumnDomains(colsForDomain, layerCate.code, i.props);
			return Object.assign(i, {
				domainsByColumn: domainsByColumn
			});
		})

		this.rules = this.resoCenterService.transformRules(this.resolverFeed.rules);
	}

	async ngOnInit() {

	}
	async ngOnChanges(changes: SimpleChanges) {
		if (changes.resolverFeed) {
			await this.onFeedChange();
		}
	}

}
